import { render, staticRenderFns } from "./NavigateToProjectDashboard.vue?vue&type=template&id=d60d8820&"
import script from "./NavigateToProjectDashboard.vue?vue&type=script&lang=js&"
export * from "./NavigateToProjectDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports